import type * as types from "./types";

import {
  type DocumentNode,
  type OperationVariables,
  type TypedDocumentNode,
  useLazyQuery,
} from "@apollo/client";
import Bugsnag from "@bugsnag/browser";

import { useClient } from "./use-client";

export function useNorthbeamLazyQuery<T, V = OperationVariables>(
  query: DocumentNode | TypedDocumentNode<T, V>,
  options?: types.QueryOptions<T, V>,
) {
  const client = useClient(options);

  const [loadData, data] = useLazyQuery<T, V>(query, {
    ...options,
    client,
  });

  if (data.error && !options?.doNotRaiseErrorOnFailure) {
    Bugsnag.setContext(
      `GraphQL lazy query failure. \nQuery: ${JSON.stringify(
        query,
      )}\nOptions: ${JSON.stringify(options)}`,
    );
    throw data.error;
  }

  return { loadData, data };
}
